// TikTok Events Tracking Utilities

// Check if we're in production environment
const shouldTrackAnalytics = () => {
  return import.meta.env.VITE_PUBLIC_APP_ENV === 'production';
};

// Helper function for TikTok tracking
export const trackTikTokEvent = (eventName, tiktokEvent = {}) => {
  if (shouldTrackAnalytics() && typeof window !== 'undefined' && window.ttq) {
    try {
      window.ttq.track(eventName, tiktokEvent);
      console.log(`TikTok event tracked: ${eventName}`, tiktokEvent);
    } catch (error) {
      console.error('TikTok tracking error:', error);
    }
  } else if (!shouldTrackAnalytics()) {
    console.log(`TikTok tracking skipped (non-production): ${eventName}`, tiktokEvent);
  } else {
    console.warn('TikTok pixel not loaded');
  }
};

// Standard TikTok Events for App Traction

export const trackTikTokViewContent = (contentName, contentType = 'page') => {
  const tiktokEvent = {
    contents: [{
      content_id: contentName.toLowerCase().replace(/\s+/g, '_'),
      content_type: contentType,
      content_name: contentName,
    }]
  };
  trackTikTokEvent('ViewContent', tiktokEvent);
};

export const trackTikTokCompleteRegistration = (userEmail) => {
  const tiktokEvent = {
    contents: [{
      content_id: 'user_registration',
      content_type: 'registration',
      content_name: 'App Traction Registration',
    }]
  };
  trackTikTokEvent('CompleteRegistration', tiktokEvent);
};

export const trackTikTokLead = (leadType, leadSource = 'website') => {
  const tiktokEvent = {
    contents: [{
      content_id: `lead_${leadType}`,
      content_type: 'lead',
      content_name: `${leadType} Lead`,
      description: `Lead generated from ${leadSource}`
    }]
  };
  trackTikTokEvent('Lead', tiktokEvent);
};

export const trackTikTokPurchase = (productId, value, currency = 'USD') => {
  const tiktokEvent = {
    contents: [{
      content_name: 'App Growth Audit Report',
      content_type: 'product',
      content_id: productId,
      value: value,
      currency: currency,
      quantity: 1
    }]
  };
  trackTikTokEvent('Purchase', tiktokEvent);
};

export const trackTikTokSubscribe = (subscriptionType = 'waitlist') => {
  const tiktokEvent = {
    contents: [{
      content_id: `subscription_${subscriptionType}`,
      content_type: 'subscription',
      content_name: `${subscriptionType} Subscription`,
    }]
  };
  trackTikTokEvent('Subscribe', tiktokEvent);
};

export const trackTikTokContact = (contactMethod = 'form') => {
  const tiktokEvent = {
    contents: [{
      content_id: `contact_${contactMethod}`,
      content_type: 'contact',
      content_name: 'Contact Form Submission',
    }]
  };
  trackTikTokEvent('Contact', tiktokEvent);
};

export const trackTikTokInitiateCheckout = (productId, value, currency = 'USD') => {
  const tiktokEvent = {
    contents: [{
      content_name: 'App Growth Audit Report',
      content_type: 'product',
      content_id: productId,
      value: value,
      currency: currency
    }]
  };
  trackTikTokEvent('InitiateCheckout', tiktokEvent);
}; 